import * as React from 'react';

import { useTranslation } from 'react-i18next';

import rockets_intro_pic from '@assets/images/welcome/rockets_intro_welcome2.png';
import pic from '@assets/images/welcome/shop_quest_pic.png';

import { Button } from '@components/button';

import { config } from '@/config.ts';

import * as Styled from './shop-quests.styled.ts';

type OwnProps = {
	onClickNext: () => void;
	onClickPrevious: () => void;
};

const isRockets = config.BRAND === 'rockets';

const ShopQuests: React.FC<OwnProps> = ({ onClickPrevious, onClickNext }) => {
	const { t } = useTranslation(['main', 'welcome', 'rockets_welcome']);

	return (
		<Styled.Wrapper $isReverse={isRockets}>
			<Styled.Content>
				<Styled.Title>
					{isRockets ? t('welcome:rockets_intro2') : t('welcome:shop_and_quests_shop')}{' '}
					{!isRockets && <span>{t('welcome:shop_and_quests_quests')}</span>}
				</Styled.Title>
				{isRockets ? (
					<Styled.Info>{t('welcome:rockets_intro2_description')}</Styled.Info>
				) : (
					<>
						<Styled.Info>
							{t('welcome:shop_and_quests_text1')}
							<Styled.Text>{t('welcome:shop_and_quests_text2')}</Styled.Text>
							<Styled.Text>{t('welcome:shop_and_quests_text3')}</Styled.Text>
						</Styled.Info>
					</>
				)}
				<Styled.ButtonGroup>
					<Button onClick={onClickPrevious} color='dark'>
						{t('back')}
					</Button>
					<Button onClick={onClickNext} color='primary'>
						{t('next')}
					</Button>
				</Styled.ButtonGroup>
			</Styled.Content>

			<Styled.Image src={isRockets ? rockets_intro_pic : pic} alt='Shop Quest' />
		</Styled.Wrapper>
	);
};

export default ShopQuests;
